export default __webpack_public_path__ + "static/media/textField.1cd37530.svg";